import React from 'react';

import '../App.css';
import Sidebar from '../components/sidebar';
import CreateReport from './Access Control/360createreport';

const Home = () => {
 

  return(
    <div>


    <Sidebar/>
    {/* <div id="container" className="container"> */}
    <CreateReport/>
    {/* </div> */}
    </div>
  );
};

export default Home;
